export default "__VITE_ASSET__Bsf7tCJQ__"